export default __webpack_public_path__ + "static/media/freemarker.b1546f86.svg";